import config from './config.api';
import locales from './locales.api';
import batch from './batch.api';
import applications from './application.api';
import applicationConfigurations from './application.configuration.api';
import dataService from './dataService.api';
import programs from './programs.api';
import templates from './template.api';
import users from './users.api';
import userGroups from './user.groups.api';
import permissions from './user.permission.api';
import me from './user.me.api';
import roles from './roles.api';
import policies from './policies.api';
import acts from './acts.api';
import tenants from './tenants.api';
import locations from './locations.api';
import organizations from './organizations.api';
import userOrganizations from './user.organizations.api';
import contacts from './organization.contacts.api';
import formTemplateConfig from './form.template.config.api';
import employees from './employees.api';
import employeesAdmin from './employees.admin.api';
import referenceData from './reference.data.api';
import consentConfigs from './consentConfigs.api';

const api = {
  config,
  applications,
  applicationConfigurations,
  locales,
  batch,
  dataService,
  users,
  userGroups,
  programs,
  permissions,
  roles,
  policies,
  acts,
  tenants,
  locations,
  organizations,
  userOrganizations,
  contacts,
  formTemplateConfig,
  employees,
  employeesAdmin,
  referenceData,
  me,
  consentConfigs,
};

export {
  config,
  applications,
  applicationConfigurations,
  locales,
  batch,
  dataService,
  users,
  userGroups,
  programs,
  templates,
  roles,
  permissions,
  policies,
  acts,
  tenants,
  locations,
  organizations,
  userOrganizations,
  contacts,
  formTemplateConfig,
  employees,
  employeesAdmin,
  referenceData,
  me,
  consentConfigs,
};

export default api;
